import React, { FC } from 'react'
import { ParticipantsAudioProps } from './types'
import Audio from '@bt-react/components/Audio'
import get from 'lodash/get'

const ParticipantsAudio: FC<ParticipantsAudioProps> = ({ tracks, muted = false }) =>
  <div data-bdd='talks-participants-audio-container'>
    {
      tracks.map(trackPublication =>
        <Audio
          trackName={trackPublication.trackName}
          trackSid={trackPublication.trackSid}
          track={get(trackPublication, 'track', null)}
          key={trackPublication.trackSid}
          isMuted={muted}
        />
      )
    }
  </div>

export default ParticipantsAudio
